

















import { Vue, Component } from 'vue-property-decorator';
import FullRule from './full-rule.vue';
import FullAlert from './full-alert.vue';
@Component({
  components: { FullAlert, FullRule }
})
export default class Full extends Vue {
  bread = [{ name: '预警管理' }, { name: '预警监督台' }];
  activeKey: number = 1;
}
